import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import DashboardLayout from "layout/Dashboard";
import { items } from "layout/Dashboard/config";
import AccountPage from "pages/dashboard/Account";
import CampaignDetails from "pages/dashboard/CampaignDetails";
import FeedbackDetails from "pages/dashboard/FeedBacks/components/FeedbackDetails";
import SurveyPreview from "pages/Survey";
import { useSelector } from "react-redux";
import { createBrowserRouter, Navigate } from "react-router-dom";

import usePermission from "shared/helpers/hooks/usePermission";
import { selectAuth } from "store/slicers/auth";
import Login from "../pages/auth/login";
import MysteryShopperDetails from "pages/dashboard/MysteryShopping/Details";
import { EFeedbackPermissions } from "resources/permissions/permissions.enum";
import { useRoutesReadPermissions } from "shared/helpers/hooks/useRoutesReadPermissions";
import Welcome from "pages/dashboard/Welcome";
import { ERoutes } from "./constants";
import LogOut from "shared/components/LogOut";
import SmsDistributionMain from "pages/dashboard/CampaignDetails/distribution/smsDistribution";
import PushDistribution from "pages/dashboard/CampaignDetails/distribution/pushDistribution";
import SmsSurvey from "pages/dashboard/Campaigns/SmsSurvey";
import EmailDistributionMain from "pages/dashboard/CampaignDetails/distribution/emailDistribution";
import ResetPasswordPage from "pages/auth/ResetPasswordPage";
import VerifyEmailCode from "pages/auth/VerifyEmailCode";
import NewPasswordPage from "pages/auth/NewPasswordPage";
import { isSessionExpired } from "shared/helpers/isSessionExpired";
import { LStorage } from "store/config/constants";

// Auth-guard проверяющий истечение срока жизни сессии
const authLoader = () => {
  if (isSessionExpired()) {
    localStorage.removeItem(LStorage.AUTH);
    window.location.assign('/login');
  }

  return null;
};

export const CreateRoutes = () => {
  const isAuthorized = useSelector(selectAuth);
  const hasPerm = useRoutesReadPermissions();
  const hasGridViewFeedbackCardPermission = usePermission(
    EFeedbackPermissions.View_feedback_card
  );

  const getDashboardRoutes = () => {
    const getChildRoutes = (item) => {
      if (item?.children?.length) {
        return {
          path: item.path,
          element: item.element,
          children: [
            ...item.children.map((child) => {
              return getChildRoutes(child);
            }),
          ],
        };
      } else {
        return {
          path: item.path,
          element: item.element,
        };
      }
    };

    return [
      ...routesList.map(getChildRoutes),
      { path: "*", element: <ErrorBoundary /> },
    ];
  };

  const routesList = items(hasPerm);

  const router = createBrowserRouter([
    {
      path: "/login",
      element: !isAuthorized ? <Login /> : <Navigate to="/admin" replace />,
    },
    {
      path: `/${ERoutes.RESET_PASSWORD}`,
      element: !isAuthorized ? (
        <ResetPasswordPage />
      ) : (
        <Navigate to="/admin" replace />
      ),
    },
    {
        path: `/${ERoutes.VERIFY_CODE}`,
        element: !isAuthorized ? (
            <VerifyEmailCode />
        ) : (
            <Navigate to="/admin" replace />
        ),
    },
    {
        path: `/${ERoutes.NEW_PASSWORD}`,
        element: !isAuthorized ? (
            <NewPasswordPage />
        ) : (
            <Navigate to="/admin" replace />
        ),
    },
    {
      path: "/admin",
      errorElement: <ErrorBoundary />,
      element: !isAuthorized ? <LogOut /> : <DashboardLayout />,
      // loader: authLoader,
      children: [
        {
          path: "",
          element: <Welcome />,
        },
        ...getDashboardRoutes(),
        {
          path: "profile",
          index: true,
          element: <AccountPage />,
        },
        ...(hasGridViewFeedbackCardPermission
          ? [
              {
                path: "response/:id",
                element: <FeedbackDetails />,
              },
            ]
          : []),
        {
          path: "survey/:id",
          element: <CampaignDetails />,
        },
        {
          path: "sms-survey/:id",
          element: <SmsSurvey />,
        },
        {
          path: "mystery-shopping/:id",
          element: <MysteryShopperDetails />,
        },
        {
          path: "sms-share/:surveyID",
          element: <SmsDistributionMain />,
        },
        {
          path: "push-share/:surveyID",
          element: <PushDistribution />,
        },
        {
          path: "email-share/:surveyID",
          element: <EmailDistributionMain />,
        },
      ],
    },
    {
      path: ":type/:hash",
      element: <SurveyPreview />,
    },
    //{
    //  path: "*",
    //  element: !isAuthorized ? (
    //    <Navigate to="/login" />
    //  ) : (
    //    <Navigate to="admin" />
    //  ),
    //},
    // {
    //   path: "*",
    //   element: <RedirectToExternal/>
    // }
  ]);

  return router;
};

export const ErrorBoundary = () => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

// export const RedirectToExternal = () => {
//     window.location.href = "https://satisfai.live";

//     return <></>
// }
